import React from 'react';
import { Modal } from 'react-bootstrap';
import cn from 'classnames';
import PODViewer from 'ui/components/imageViewer';

export const Document = ({ data }) => {
  return (
    <>
      <Modal.Body>
        <div
          className={cn(
            'd-flex flex-wrap pt-2',
            'gap-2 align-items-center justify-content-center'
          )}
        >
          <PODViewer
            items={data?.attachments}
            imgStyle={{ height: 80, width: 80, objectFit: 'cover' }}
            imgClass="img-hover img-responsive rounded-3"
            wrapperClass="row mt-2 w-100"
            imgWrapperClass="col-6 p-2 border-1 border justify-content-center align-items-center d-flex flex-column"
          />
        </div>
      </Modal.Body>
    </>
  )
}